module.exports = __webpack_public_path__ + "img/1970East-055_WEB-min.242b38a6.jpg";